import { BaseEntity } from '../../base-entity';

export enum CrmAccountType {
  Company = 'company', // חברה בע"מ
  Association = 'association', // עמותה
  NonProfit = 'non_profit', // מלכ"ר / חל"צ
  SelfEmployed = 'self_employed', // עצמאי
  Government = 'government', // גוף ממשלתי
  Institution = 'institution', // מוסד
  Individual = 'individual', // אינדיבידואל
  Other = 'other', // אחר
}

export enum CrmVatStatus {
  VatRegistered = 'vat_registered', // עוסק מורשה
  VatExempt = 'vat_exempt', // עוסק פטור
}

export interface CrmAccountEntity extends BaseEntity {
  id: number;
  accountName: string;
  accountType: CrmAccountType | null;
  vatStatus: CrmVatStatus | null;
  registrationNumber: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  notes: string | null;
}
